import { format, subDays, subMonths } from 'date-fns';
import React, { useState, useRef, useEffect } from 'react';
import { FiFilter } from 'react-icons/fi';

const Filter = ({ onApplyFilter, tags }) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedTag, setSelectedTag] = useState('');
  const [selectedTimeFilter, setSelectedTimeFilter] = useState('all');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const filterRef = useRef(null);

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const handleTagChange = (e) => {
    setSelectedTag(e.target.value);
  };

  const handleTimeFilterChange = (e) => {
    setSelectedTimeFilter(e.target.value);
  };

  const handleApplyFilter = () => {
    const filters = {};

    // Handle tag filter
    if (selectedTag) {
      filters.tag_id = selectedTag;
    }

    // Handle time filters
    const today = new Date();

    if (selectedTimeFilter === 'week') {
      filters.start_at = format(subDays(today, 7), 'yyyy-MM-dd');
      filters.end_at = format(today, 'yyyy-MM-dd');
      filters.time_filter = 'pekan terakhir';
    } else if (selectedTimeFilter === 'month') {
      filters.start_at = format(subMonths(today, 1), 'yyyy-MM-dd');
      filters.end_at = format(today, 'yyyy-MM-dd');
      filters.time_filter = 'bulan terakhir';
    } else if (selectedTimeFilter === 'custom' && startDate && endDate) {
      filters.start_at = startDate;
      filters.end_at = endDate;
      filters.time_filter = 'rentang waktu';
    }

    onApplyFilter(filters);
    setIsFilterOpen(false); // Close filter after applying
  };

  // Close filter if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsFilterOpen(false);
      }
    };

    if (isFilterOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isFilterOpen]);

  return (
    <div className="relative" ref={filterRef}>
      <button
        type="button"
        onClick={toggleFilter}
        className="flex items-center px-4 py-2 bg-white border border-gray-300 rounded-full shadow-sm text-gray-600 hover:bg-gray-100"
      >
        <FiFilter className="mr-2" />
        Filter
      </button>

      {/* Filter Dropdown */}
      {isFilterOpen && (
        <div className="absolute top-12 right-0 w-96 bg-white border border-gray-200 shadow-lg rounded-lg p-4 z-50">
          <div className="mb-4">
            {/* Tag Dropdown */}
            <label className="block text-sm font-medium text-gray-700 mb-2">Tag</label>
            <select
              value={selectedTag}
              onChange={handleTagChange}
              className="block w-full border border-gray-300 rounded-lg py-2 px-3 text-gray-700 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">All Tags</option>
              {tags.map((tag) => (
                <option key={tag.id} value={tag.id}>
                  {tag.name}
                </option>
              ))}
            </select>
          </div>

          <hr />

          {/* Time Filter */}
          <div className="mt-4">
            <p className="text-sm font-medium text-gray-700">Filter Waktu</p>
            <div className="flex flex-col mt-2 space-y-2">
              <label htmlFor="all" className="inline-flex items-center">
                <input
                  id="all"
                  type="radio"
                  value="all"
                  checked={selectedTimeFilter === 'all'}
                  onChange={handleTimeFilterChange}
                  className="form-radio text-blue-500"
                />
                <span className="ml-2">Semua</span>
              </label>
              <label htmlFor="week" className="inline-flex items-center">
                <input
                  id="week"
                  type="radio"
                  value="week"
                  checked={selectedTimeFilter === 'week'}
                  onChange={handleTimeFilterChange}
                  className="form-radio text-blue-500"
                />
                <span className="ml-2">Pekan Terakhir</span>
              </label>
              <label htmlFor="month" className="inline-flex items-center">
                <input
                  id="month"
                  type="radio"
                  value="month"
                  checked={selectedTimeFilter === 'month'}
                  onChange={handleTimeFilterChange}
                  className="form-radio text-blue-500"
                />
                <span className="ml-2">Bulan Terakhir</span>
              </label>
              <label htmlFor="custom" className="inline-flex items-center">
                <input
                  id="custom"
                  type="radio"
                  value="custom"
                  checked={selectedTimeFilter === 'custom'}
                  onChange={handleTimeFilterChange}
                  className="form-radio text-blue-500"
                />
                <span className="ml-2">Rentang Waktu</span>
              </label>
            </div>

            {/* Custom Date Range */}
            {selectedTimeFilter === 'custom' && (
              <div className="mt-4 flex space-x-4">
                <div className="w-1/2">
                  <label className="text-sm text-gray-700">Dari</label>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="block w-full mt-1 border border-gray-300 rounded-lg py-2 px-3"
                  />
                </div>
                <div className="w-1/2">
                  <label className="text-sm text-gray-700">Sampai</label>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="block w-full mt-1 border border-gray-300 rounded-lg py-2 px-3"
                  />
                </div>
              </div>
            )}
          </div>

          {/* Apply Button */}
          <button
            type="button"
            onClick={handleApplyFilter}
            className="mt-6 w-full py-2 px-4 bg-orange-500 text-white font-semibold rounded-lg shadow hover:bg-orange-600"
          >
            Terapkan
          </button>
        </div>
      )}
    </div>
  );
};

export default Filter;
